import { Link } from "react-router-dom";
import { DiscoverButton } from "./../../index";

const ProductCard = ({ img, title, url, onClick }) => {
  let imgSrc = "";
  try {
    imgSrc = require("./../../../assets/img/" + img + ".jpg").default;
  } catch {
    imgSrc = undefined;
  }

  return (
    <Link to={url} className="product-cards-link" onClick={onClick}>
      {imgSrc === undefined ? (
        <div className="product-cards-image"></div>
      ) : (
        <img
          className="product-cards-image"
          src={imgSrc}
          alt={img}
          onError={(e) => (e.target.src = null)}
        />
      )}
      <div className="product-cards-title">
        <p>{title}</p>
        <DiscoverButton />
      </div>
    </Link>
  );
};

export default ProductCard;
